import { TipoAtendimentoEnum } from 'graphql/types.generated'
import { SoapEditableItem } from 'view/atendimentos/atendimento-individual/model'

export interface OrientacaoRowModel extends SoapEditableItem {
  cacheId?: ID
  /**
   * Database id
   */
  id?: ID
  descricao: string
  atendimentoProfissional: {
    id: ID
    iniciadoEm: Instant
    atendimento?: {
      id: ID
      localAtendimento?: {
        id: ID
        localAtendimentoExibicao?: string
      }
    }
    tipoAtendimento?: TipoAtendimentoEnum
    lotacao: {
      id: ID
      cbo: {
        id: ID
        nome: string
        cbo2002?: string
      }
      profissional: {
        id: ID
        nome: string
        numeroConselhoClasse?: string
        conselhoClasse?: {
          id: ID
          sigla: string
        }
        ufEmissoraConselhoClasse?: {
          id: ID
          nome: string
          sigla: string
        }
      }
      municipio?: {
        id: ID
        nome: string
        uf: {
          id: ID
          nome: string
          sigla: string
        }
      }
      unidadeSaude: {
        id: ID
        nome?: string
      }
    }
  }
}

export interface OrientacaoFormModel extends SoapEditableItem {
  descricao: string
}

export interface OrientacaoFilterModel {
  texto: string
  somenteMeus: boolean
}

export const tipoAtendimentoRecord: Record<TipoAtendimentoEnum, string> = {
  [TipoAtendimentoEnum.CONSULTA]: 'Consulta',
  [TipoAtendimentoEnum.CONSULTA_NO_DIA]: 'Consulta no dia',
  [TipoAtendimentoEnum.URGENCIA]: 'Urgência',
  [TipoAtendimentoEnum.CONSULTA_AGENDADA_CUIDADO_CONTINUADO]: 'Consulta agendada',
}
